module.exports = __webpack_public_path__ + "static/media/4.ff1a4269.png";